
import { defineComponent } from 'vue';

export default defineComponent({
    props: {
        title: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            show: false,
        };
    },
    beforeDestroy() {
        document.removeEventListener('click', this.documentClick);
    },
    methods: {
        toggle(event: Event) {
            this.show = !this.show;
            if (this.show) {
                document.addEventListener('click', this.documentClick);
            } else {
                document.removeEventListener('click', this.documentClick);
            }
        },
        documentClick(event: Event) {
            this.show = false;
            document.removeEventListener('click', this.documentClick);
        },
    },
});
